import { MDBBtn, MDBBtnGroup, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCardTitle, MDBIcon, MDBTooltip } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { UserProfileContext } from '../context/UserProfileProvider';
// eslint-disable-next-line react/display-name
const RecursiveFeature = React.memo(({
  feature,
  index,
  parentPath = '', // Add parentPath to track nested levels
  handleRemoveSubFeature,
  setSelectedFeature,
  setActiveFeatureIndex,
  toggleFeatureListModal,isEdit
}) => {
  const { tokenLoaded } = useContext(UserProfileContext);

  const featurePath = parentPath !== '' ? `${String(parentPath)}-${index}` : `${index}`;



  return (
    <div className="sub-feature-section">
      <MDBCard className="mb-3">

      <div
                  className="bg-image hover-overlay shadow-4-strong rounded mx-3"
                  data-mdb-ripple-color="light"
                  style={{ marginTop: '-15px' }}
                >
                  {/* Feature Image */}
                  <MDBCardImage
                    src={feature.imageUrl || 'https://opengrit.com/images/defaultakada'}
                    className="img-fluid"
                    style={{ maxHeight: '200px' }}
                  />
                  <a href="#!">
                    <div className="mask" style={{ backgroundColor: 'rgba(251, 251, 251, 0.15)' }}></div>
                  </a>
                </div>
             


        <MDBCardBody>
          <MDBCardTitle>{feature?.name || `Sub-Feature ${index + 1}`}</MDBCardTitle>
          <MDBCardText className='text-start'>
            {feature.paragrapDescriptions && feature.paragrapDescriptions.length > 0
              ? feature.paragrapDescriptions[0]?.heading.textValue || feature.paragrapDescriptions[0].textValue
              : 'No text available'}
          </MDBCardText>

          <MDBBtnGroup className='align-items-center justify-content-between gap-1'>
            <MDBBtn
              type='button'
              tag='a'
              color='none'
              className='m-1'
              style={{ color: '#dd4b39' }}
              onClick={() => {
                setSelectedFeature(feature);
                setActiveFeatureIndex(featurePath); // Pass the full path as the index
                toggleFeatureListModal();
              }}
            >
              <MDBTooltip tag="a" wrapperProps={{ href: '#' }} title="Read More">
                <MDBIcon fab icon="readme" style={{ color: '#dd4b39' }} />
              </MDBTooltip>
            </MDBBtn>

    

            {/* Button to Remove Sub-Feature */}
            {tokenLoaded && isEdit && (
              <MDBBtn
                type='button'
                tag='a'
                color='none'
                className='m-1'
                style={{ color: '#ac2bac' }}
                onClick={() => handleRemoveSubFeature(index)}
              >
                <MDBTooltip tag="a" wrapperProps={{ href: '#' }} title="Remove Sub-Feature">
                  <MDBIcon fas icon="times-circle" style={{ color: '#ac2bac' }} />
                </MDBTooltip>
              </MDBBtn>
            )}
          </MDBBtnGroup>

          {/* Recursively Render Sub-Features */}
          {feature.subFeatures && feature.subFeatures.length > 0 && (
  <div className="mt-3 ms-3">
    {feature.subFeatures.map((subFeature, subIndex) => (
      <RecursiveFeature
        key={`nested-sub-feature-${subIndex}`}
        feature={subFeature}
        index={subIndex}
        parentPath={featurePath} // Pass down the current full path, e.g., '0-1'
        handleRemoveSubFeature={() => handleRemoveSubFeature(subIndex)}
        setSelectedFeature={setSelectedFeature}
        setActiveFeatureIndex={setActiveFeatureIndex}
        toggleFeatureListModal={toggleFeatureListModal}
      />
    ))}
  </div>
)}

        </MDBCardBody>
      </MDBCard>
    </div>
  );
});


// Define PropTypes with validation for nested structures
RecursiveFeature.propTypes = {
  feature: PropTypes.shape({
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    paragrapDescriptions: PropTypes.arrayOf(
      PropTypes.shape({
        textValue: PropTypes.string,
        orderNumber: PropTypes.number,
        heading: PropTypes.shape({
          textValue: PropTypes.string,
          orderNumber: PropTypes.number,
        }),
      })
    ),
    subFeatures: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number.isRequired,
  parentPath: PropTypes.string,
  handleRemoveSubFeature: PropTypes.func.isRequired,
  setSelectedFeature: PropTypes.func.isRequired,
  setActiveFeatureIndex: PropTypes.func.isRequired,
  toggleFeatureListModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

export default RecursiveFeature;
